"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverclaimViewHeader = void 0;
const react_1 = __importDefault(require("react"));
const BackButton_1 = __importDefault(require("@Components/Buttons/BackButton"));
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const OverclaimHeaderDescription_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/OverclaimHeader/OverclaimHeaderDescription"));
const OverclaimViewHeader = (props) => {
    const { songTitle, amendingShares } = props;
    return (react_1.default.createElement(ContentHeader_1.default, { title: songTitle + ' - Overclaim Detail', navLeft: react_1.default.createElement(BackButton_1.default, null), descriptionElement: react_1.default.createElement(OverclaimHeaderDescription_1.default, { amendingShares: amendingShares }) }));
};
exports.OverclaimViewHeader = OverclaimViewHeader;
